import { Rect } from '../../../platform/geom/Rect';
import { StatePropertyRef } from '../../canvas/ExtendableStore';

export type ActiveCallFaceStateKey = 'none' | 'detected';
export interface ActiveCallFaceInfo {
    state: ActiveCallFaceStateKey;
    area?: Rect;
}

export const CreateActiveCallFaceInfo = (area?: Rect) => ({ state: !!area ? 'detected' : 'none', area }) as ActiveCallFaceInfo;
export const ActiveCallFaceInfo = StatePropertyRef<ActiveCallFaceInfo>('activeCallFace', CreateActiveCallFaceInfo());
